import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconMessage1Write = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 22'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M12.000,19.000 L10.565,19.000 C8.608,21.845 4.223,21.995 4.026,22.000 C4.018,22.000 4.009,22.000 4.000,22.000 C3.622,22.000 3.275,21.786 3.106,21.446 C2.932,21.098 2.977,20.681 3.218,20.376 C3.234,20.356 4.655,18.549 4.936,16.656 C2.446,15.410 0.000,12.775 0.000,9.461 C0.000,4.244 5.383,-0.000 12.000,-0.000 C18.617,-0.000 24.000,4.244 24.000,9.461 C24.000,14.721 18.617,19.000 12.000,19.000 ZM12.000,2.000 C6.486,2.000 2.000,5.347 2.000,9.461 C2.000,12.025 4.191,14.240 6.355,15.103 C6.735,15.254 6.984,15.623 6.984,16.032 C6.984,17.359 6.512,18.656 6.004,19.667 C7.160,19.350 8.496,18.734 9.111,17.541 C9.283,17.209 9.626,17.000 10.000,17.000 L12.000,17.000 C17.514,17.000 22.000,13.618 22.000,9.461 C22.000,5.347 17.514,2.000 12.000,2.000 ZM15.000,9.000 L17.000,9.000 L17.000,11.000 L15.000,11.000 L15.000,9.000 ZM11.000,9.000 L13.000,9.000 L13.000,11.000 L11.000,11.000 L11.000,9.000 ZM7.000,9.000 L9.000,9.000 L9.000,11.000 L7.000,11.000 L7.000,9.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconMessage1Write.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
